module.exports = __webpack_public_path__ + "32d04882890bf2ff65315206e0c86db2.woff";